import {
    PlayerBaseInfoContent,
    usePlayerBaseInfoContext,
} from '@/scenarios/legacy-player/components/player-manager/context/PlayerBaseInfoProvider';

export function useReadPlayerBaseInfo(
    contentId: string
): { content: PlayerBaseInfoContent } | null | undefined {
    const { getPlayerBaseInfo } = usePlayerBaseInfoContext();
    if (!contentId) {
        return undefined;
    }

    return getPlayerBaseInfo() ?? undefined;
}
